<header class="header">
  <div class="virsaLogo">
    <a routerLink="/">
      <img loading="lazy" class="virsa_Logo"
        src="https://d3uop73ba1wtqg.cloudfront.net/uploads/WukKVLVAK6kTax6HpziPQWWZPU0av6Zo2E2U8wCs.png"
        alt="virsa logo" />
    </a>
  </div>

  <!-- NAVIGATION LINKS -->
  <ul class="nav_link_list" [ngClass]="{ show: isNavListVisible }">
    <li class="nav_item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      <a class="header-link" routerLink="/" (click)="toggleNavList('set')">
        <span>Home</span>
      </a>
    </li>
    <li class="nav_item" routerLinkActive="active">
      <a class="header-link" routerLink="/about-us" (click)="toggleNavList('set')">
        <span>About Us</span>
      </a>
    </li>

    <!-- PRODUCTS DROPDOWN -->
    <li class="nav_item">
      <div class="mobile-dropdown">
        <button mat-button class="header-link" [ngClass]="{ 'expanded': isProductsExpanded }"
          [matMenuTriggerFor]="productsMenu" #productsMenuTrigger="matMenuTrigger" (click)="toggleProductsDropdown()"
          routerLink="/products" (mouseenter)="openProductsMenu()" (mouseleave)="closeProductsMenu()">
          <span class="nav-label-container">
            <span>Products</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </span>
        </button>

        <!-- Mobile Dropdown Content -->
        <div class="dropdown-content" *ngIf="isProductsExpanded">
          <a class="dropdown-item" routerLink="/interactive-flat-panel-smart-classroom" (click)="toggleNavList('set')">
            Interactive Flat Panel
          </a>
          <a class="dropdown-item" routerLink="/all-in-one-pc-computers-accessories" (click)="toggleNavList('set')">
            All In One PC
          </a>
          <a class="dropdown-item" routerLink="/shutter-system" (click)="toggleNavList('set')">
            IFP Protection (Shutter)
          </a>
          <a class="dropdown-item" routerLink="/lms" (click)="toggleNavList('set')">
            LMS
          </a>
          <a class="dropdown-item" routerLink="/k-12-digital-content" (click)="toggleNavList('set')">
            K-12 Digital Content
          </a>
          <a class="dropdown-item" routerLink="/digital-e-library" (click)="toggleNavList('set')">
            Digital E-Library
          </a>
        </div>

        <!-- Desktop Menu (hidden on mobile) -->
        <mat-menu #productsMenu="matMenu" class="genre_menu" [overlapTrigger]="false" [hasBackdrop]="false">
          <div (mouseenter)="openProductsMenu()" (mouseleave)="closeProductsMenu()">
            <button mat-menu-item routerLink="/interactive-flat-panel-smart-classroom">
              Interactive Flat Panel
            </button>
            <button mat-menu-item routerLink="/shutter-system">
              IFP Protection (Shutter)
            </button>
            <button mat-menu-item routerLink="/all-in-one-pc-computers-accessories">
              All In One PC
            </button>
            <button mat-menu-item routerLink="/lms">
              LMS
            </button>
            <button mat-menu-item routerLink="/k-12-digital-content">
              K-12 Digital Content
            </button>
            <button mat-menu-item routerLink="/digital-e-library">
              Digital E-Library
            </button>
          </div>
        </mat-menu>
      </div>
    </li>

    <!-- SOLUTIONS DROPDOWN -->
    <li class="nav_item">
      <div class="mobile-dropdown">
        <button mat-button class="header-link" [ngClass]="{ 'expanded': isSolutionsExpanded }"
          [matMenuTriggerFor]="solutionsMenu" #solutionsMenuTrigger="matMenuTrigger" (click)="toggleSolutionsDropdown()"
          routerLink="/solutions" (mouseenter)="openSolutionsMenu()" (mouseleave)="closeSolutionsMenu()">
          <span class="nav-label-container">
            <span>Solutions</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </span>
        </button>

        <!-- Mobile Dropdown Content -->
        <div class="dropdown-content" *ngIf="isSolutionsExpanded">
          <a class="dropdown-item" routerLink="/solutions/schools" (click)="toggleNavList('set')">
            Schools
          </a>
          <a class="dropdown-item" routerLink="/solutions/education-institutions" (click)="toggleNavList('set')">
            Education Institutions
          </a>
          <a class="dropdown-item" routerLink="/solutions/corporates" (click)="toggleNavList('set')">
            Corporates
          </a>
          <a class="dropdown-item" routerLink="/solutions/government" (click)="toggleNavList('set')">
            Government
          </a>
          <a class="dropdown-item" routerLink="/solutions/partners" (click)="toggleNavList('set')">
            Partners
          </a>
        </div>

        <!-- Desktop Menu (hidden on mobile)-->
        <mat-menu #solutionsMenu="matMenu" class="genre_menu" [overlapTrigger]="false" [hasBackdrop]="false">
          <div (mouseenter)="openSolutionsMenu()" (mouseleave)="closeSolutionsMenu()">
            <button mat-menu-item routerLink="/solutions/schools">
              Schools
            </button>
            <button mat-menu-item routerLink="/solutions/education-institutions">
              Education Institutions
            </button>
            <button mat-menu-item routerLink="/solutions/corporates">
              Corporates
            </button>
            <button mat-menu-item routerLink="/solutions/government">
              Government
            </button>
            <button mat-menu-item routerLink="/solutions/partners">
              Partners
            </button>
          </div>
        </mat-menu>
      </div>
    </li>

    <li class="nav_item" routerLinkActive="active">
      <a class="header-link" routerLink="/resources" (click)="toggleNavList('set')">
        <span>Resources</span>
      </a>
    </li>



    <li class="nav_item" routerLinkActive="active">
      <a class="header-link" routerLink="/partner" (click)="toggleNavList('set')">
        <span>Partners</span>
      </a>
    </li>

    <li class="nav_item" routerLinkActive="active">
      <a class="header-link" routerLink="/form/contactUs" (click)="toggleNavList('set')">
        <span>Contact Us</span>
      </a>
    </li>

    <!-- MOBILE ACTION BUTTONS -->
    <div class="mobile-actions" *ngIf="!userSignedIn">
      <button class="btn-book-demo" (click)="openBookDemo(); toggleNavList('set')">Schedule a Demo</button>
      <button class="btn-login" (click)="openLogIn(); toggleNavList('set')">Explore Our Cultural Classes</button>
    </div>

    <!-- MOBILE USER INFO (if signed in) -->
    <div class="mobile-actions" *ngIf="userSignedIn">
      <div class="user-mobile-info">
        <div class="user-details">
          <strong>{{ Cap(data.user.first_name + " " + data.user.last_name) }}</strong>
          <small>ID: {{ data.virsa_id }}</small>
        </div>
        <div class="coin-display">
          <img loading="lazy" class="coin me-2"
            src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_coin.png" alt="reward_coins" />
          <span>0 Coins</span>
        </div>
      </div>
      <button class="btn-login" (click)="signOut(); toggleNavList('set')">Sign Out</button>
    </div>
  </ul>

  <!-- RIGHT SIDE MENU (Desktop) -->
  <div class="right-actions">
    <ng-container *ngIf="!userSignedIn">
      <button class="btn-book-demo" (click)="openBookDemo()">Schedule a Demo</button>
      <button class="btn-login" (click)="openLogIn()">Explore Our Cultural Classes</button>
    </ng-container>

    <ul class="nav_list" *ngIf="userSignedIn">
      <li class="nav_item">
        <img loading="lazy" class="coin ms-3 me-2"
          src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_coin.png" alt="reward_coins" />0
      </li>

      <li class="nav_item">
        <button mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="User Menu">
          <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <div class="user-info">
            <div>
              Name: {{ Cap(data.user.first_name + " " + data.user.last_name) }}
            </div>
            <div>Id: {{ data.virsa_id }}</div>
          </div>

          <mat-divider></mat-divider>

          <button mat-menu-item routerLink="/profile/my-virsa">
            <mat-icon>person</mat-icon><span>My Account</span>
          </button>
          <button mat-menu-item routerLink="/profile/my-genre">
            <mat-icon>music_note</mat-icon><span>My Genre</span>
          </button>
          <button mat-menu-item routerLink="/profile/workshop">
            <mat-icon>video_library</mat-icon><span>My Workshop</span>
          </button>
          <button mat-menu-item routerLink="/profile/change-interest">
            <mat-icon>local_activity</mat-icon><span>Change Interest</span>
          </button>

          <mat-divider></mat-divider>

          <button mat-menu-item (click)="signOut()">
            <span>Sign Out</span>
          </button>
        </mat-menu>
      </li>
    </ul>

    <!-- Mobile Nav Toggle -->
    <div class="nav_item menu-btn" (click)="toggleNavList()">
      <mat-icon>menu</mat-icon>
    </div>
  </div>
</header>